import Hero from "../components/Hero";
import About from "./About";
import Residential from "../pages/properties/Residential";
import SobhaRealty from "./SobhaRealty";
import Contact from "./Contact";

export default function Home() {
  return (
    <>
      <Hero />

      <section className="page-section">
        <h2>Trusted Real Estate Experts</h2>
        <p>We help you buy, sell, and rent properties easily.</p>
      </section>

      {/* Residential Properties Section */}
      <Residential />

      {/* Sobha Realty Section */}
      <SobhaRealty />

      {/* Contact Section */}
      <Contact />
    </>
  );
}
